<script lang="ts" setup>
import { ref } from 'vue';

import type { LabelFormatterTypes } from '@apps/main/new-desktop/core/components/formatters';
import {
  LabelFormatter,
  getLabelFormatterPropsForSingleValue,
} from '@apps/main/new-desktop/core/components/formatters';

import { AppSlider } from '@libs/ui';
import type { IngredientId } from '@libs/trip-planner-interfaces';

import { FilterType, FilterUpdateEventType } from '../../Filters.model';

import { SliderFilterState } from './SliderFilter.model';
import type {
  SliderUpdateFilterEvent,
  SliderFilterData,
} from './SliderFilter.model';

interface FlightsFiltersProps {
  data: SliderFilterData;
}

const props = defineProps<FlightsFiltersProps>();

interface SliderFilterEmits {
  (eventName: 'update', context: SliderUpdateFilterEvent): void;
}

const emit = defineEmits<SliderFilterEmits>();

const labelFormatter = ref<LabelFormatterTypes | undefined>();

function update(value: number, ingredientId: IngredientId): void {
  emit('update', {
    eventType: FilterUpdateEventType.UpdateFilter,
    filterType: FilterType.Slider,
    value,
    ingredientId,
  });
}

function updateLabel(
  value: number,
  labelFormatterType: LabelFormatterTypes
): void {
  labelFormatter.value = getLabelFormatterPropsForSingleValue(
    labelFormatterType,
    value
  );
}
</script>

<template>
  <div class="slider-filter">
    <template v-if="props.data.state === SliderFilterState.Default">
      <p class="title">{{ props.data.title }}</p>
      <LabelFormatter :data="labelFormatter || props.data.labelFormatter" />
      <AppSlider
        v-bind="props.data.options"
        @update-value="update($event, props.data.options.id)"
        @slide-value="updateLabel($event, props.data.labelFormatter)"
      />
    </template>
    <template v-else>
      <p class="title">{{ props.data.title }}</p>
      <div class="loading" />
    </template>
  </div>
</template>

<style scoped lang="scss">
.slider-filter {
  .title {
    @include font-label-l-light;
  }
  .loading {
    @include animated-background-secondary;
    height: 57px;
    border-radius: var(--border-radius-12);
    color: transparent;
  }
}
</style>
